module.exports = __webpack_public_path__ + "static/media/garage 1.1e58181b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/garage 1.svg
// module id = 3206
// module chunks = 0